module.exports = __webpack_public_path__ + "img/antes_despues_23.2c13a0ab.png";